module.exports = __webpack_public_path__ + "img/What_are_you_talking_about.6930ba25.png";